import React from 'react';
import { __ } from '@wordpress/i18n';
import { isNil } from 'ramda';

// tools
import getDateTimeFromISOstring from '../../../../helpers/getDateTimeFromISOstring';
import getDateFromISOstring from '../../../../helpers/getDateFromISOstring';
import getBandoLabel from '../../../../helpers/getBandoLabel';
import getNumberWithCurrency from '../../../../helpers/getNumberWithCurrency';

const APP_HUB_ID = process.env.REACT_APP_HUB_ID;

const ApplicationInfo = ({ data }) => {
    return (
        !isNil(data)
            ? <div className="appPageSection__withBorder columns">
                <p className="appPageSection__pMeta">
                    <span>{__('ID Reg', 'htr')}</span>
                    <span>{data.applicationId}</span>
                </p>
                <p className="appPageSection__pMeta">
                    <span>{__('Form', 'htr')}</span>
                    <span>{data.callName}</span>
                </p>
                <p className="appPageSection__pMeta">
                    <span>{__('Data ricezione', 'htr')}</span>
                    <span>{getDateTimeFromISOstring(data.submissionDate)}</span>
                </p>
                <p className="appPageSection__pMeta">
                    <span>{__('Assegnato a', 'htr')}</span>
                    <span>{data.assignedUserName}</span>
                </p>
                <p className="appPageSection__pMeta">
                    <span>{__('Nome', 'htr')}</span>
                    <span>{data.beneficiary}</span>
                </p>
                <p className="appPageSection__pMeta">
                    <span>{__('Azienda', 'htr')}</span>
                    <span>{data.companyName}</span>
                </p>
                <p className="appPageSection__pMeta">
                    <span>{__('Partita IVA', 'htr')}</span>
                    <span>{data.companyVatNumber}</span>
                </p>
                <p className="appPageSection__pMeta">
                    <span>{__('Stato', 'htr')}</span>
                    <span>{getBandoLabel(data.applicationStatus)}</span>
                </p>
            </div> : null
    )
}

export default ApplicationInfo;